import React, { useState, useEffect } from 'react';
import { 
  User, 
  Mail, 
  Phone, 
  Lock, 
  Camera, 
  Upload,
  Eye,
  EyeOff,
  Check,
  X,
  Globe,
  Languages,
  FileText,
  Shield,
  ChevronDown,
  Search,
  ArrowLeft,
  ArrowRight
} from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || import.meta.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Liste complète des pays - Norme ISO 3166 avec codes téléphoniques (ordre alphabétique)
const COUNTRIES = [
  { code: 'AF', name: 'Afghanistan', flag: '🇦🇫', phone: '+93' },
  { code: 'AL', name: 'Albania', flag: '🇦🇱', phone: '+355' },
  { code: 'DZ', name: 'Algeria', flag: '🇩🇿', phone: '+213' },
  { code: 'AD', name: 'Andorra', flag: '🇦🇩', phone: '+376' },
  { code: 'AO', name: 'Angola', flag: '🇦🇴', phone: '+244' },
  { code: 'AG', name: 'Antigua and Barbuda', flag: '🇦🇬', phone: '+1268' },
  { code: 'AR', name: 'Argentina', flag: '🇦🇷', phone: '+54' },
  { code: 'AM', name: 'Armenia', flag: '🇦🇲', phone: '+374' },
  { code: 'AU', name: 'Australia', flag: '🇦🇺', phone: '+61' },
  { code: 'AT', name: 'Austria', flag: '🇦🇹', phone: '+43' },
  { code: 'AZ', name: 'Azerbaijan', flag: '🇦🇿', phone: '+994' },
  { code: 'BS', name: 'Bahamas', flag: '🇧🇸', phone: '+1242' },
  { code: 'BH', name: 'Bahrain', flag: '🇧🇭', phone: '+973' },
  { code: 'BD', name: 'Bangladesh', flag: '🇧🇩', phone: '+880' },
  { code: 'BB', name: 'Barbados', flag: '🇧🇧', phone: '+1246' },
  { code: 'BY', name: 'Belarus', flag: '🇧🇾', phone: '+375' },
  { code: 'BE', name: 'Belgium', flag: '🇧🇪', phone: '+32' },
  { code: 'BZ', name: 'Belize', flag: '🇧🇿', phone: '+501' },
  { code: 'BJ', name: 'Benin', flag: '🇧🇯', phone: '+229' },
  { code: 'BT', name: 'Bhutan', flag: '🇧🇹', phone: '+975' },
  { code: 'BO', name: 'Bolivia', flag: '🇧🇴', phone: '+591' },
  { code: 'BA', name: 'Bosnia and Herzegovina', flag: '🇧🇦', phone: '+387' },
  { code: 'BW', name: 'Botswana', flag: '🇧🇼', phone: '+267' },
  { code: 'BR', name: 'Brazil', flag: '🇧🇷', phone: '+55' },
  { code: 'BN', name: 'Brunei', flag: '🇧🇳', phone: '+673' },
  { code: 'BG', name: 'Bulgaria', flag: '🇧🇬', phone: '+359' },
  { code: 'BF', name: 'Burkina Faso', flag: '🇧🇫', phone: '+226' },
  { code: 'BI', name: 'Burundi', flag: '🇧🇮', phone: '+257' },
  { code: 'CV', name: 'Cabo Verde', flag: '🇨🇻', phone: '+238' },
  { code: 'KH', name: 'Cambodia', flag: '🇰🇭', phone: '+855' },
  { code: 'CM', name: 'Cameroon', flag: '🇨🇲', phone: '+237' },
  { code: 'CA', name: 'Canada', flag: '🇨🇦', phone: '+1' },
  { code: 'CF', name: 'Central African Republic', flag: '🇨🇫', phone: '+236' },
  { code: 'TD', name: 'Chad', flag: '🇹🇩', phone: '+235' },
  { code: 'CL', name: 'Chile', flag: '🇨🇱', phone: '+56' },
  { code: 'CN', name: 'China', flag: '🇨🇳', phone: '+86' },
  { code: 'CO', name: 'Colombia', flag: '🇨🇴', phone: '+57' },
  { code: 'KM', name: 'Comoros', flag: '🇰🇲', phone: '+269' },
  { code: 'CG', name: 'Congo', flag: '🇨🇬', phone: '+242' },
  { code: 'CD', name: 'Congo (Democratic Republic)', flag: '🇨🇩', phone: '+243' },
  { code: 'CR', name: 'Costa Rica', flag: '🇨🇷', phone: '+506' },
  { code: 'CI', name: 'Côte d\'Ivoire', flag: '🇨🇮', phone: '+225' },
  { code: 'HR', name: 'Croatia', flag: '🇭🇷', phone: '+385' },
  { code: 'CU', name: 'Cuba', flag: '🇨🇺', phone: '+53' },
  { code: 'CY', name: 'Cyprus', flag: '🇨🇾', phone: '+357' },
  { code: 'CZ', name: 'Czech Republic', flag: '🇨🇿', phone: '+420' },
  { code: 'DK', name: 'Denmark', flag: '🇩🇰', phone: '+45' },
  { code: 'DJ', name: 'Djibouti', flag: '🇩🇯', phone: '+253' },
  { code: 'DM', name: 'Dominica', flag: '🇩🇲', phone: '+1767' },
  { code: 'DO', name: 'Dominican Republic', flag: '🇩🇴', phone: '+1809' },
  { code: 'EC', name: 'Ecuador', flag: '🇪🇨', phone: '+593' },
  { code: 'EG', name: 'Egypt', flag: '🇪🇬', phone: '+20' },
  { code: 'SV', name: 'El Salvador', flag: '🇸🇻', phone: '+503' },
  { code: 'GQ', name: 'Equatorial Guinea', flag: '🇬🇶', phone: '+240' },
  { code: 'ER', name: 'Eritrea', flag: '🇪🇷', phone: '+291' },
  { code: 'EE', name: 'Estonia', flag: '🇪🇪', phone: '+372' },
  { code: 'SZ', name: 'Eswatini', flag: '🇸🇿', phone: '+268' },
  { code: 'ET', name: 'Ethiopia', flag: '🇪🇹', phone: '+251' },
  { code: 'FJ', name: 'Fiji', flag: '🇫🇯', phone: '+679' },
  { code: 'FI', name: 'Finland', flag: '🇫🇮', phone: '+358' },
  { code: 'FR', name: 'France', flag: '🇫🇷', phone: '+33' },
  { code: 'GA', name: 'Gabon', flag: '🇬🇦', phone: '+241' },
  { code: 'GM', name: 'Gambia', flag: '🇬🇲', phone: '+220' },
  { code: 'GE', name: 'Georgia', flag: '🇬🇪', phone: '+995' },
  { code: 'DE', name: 'Germany', flag: '🇩🇪', phone: '+49' },
  { code: 'GH', name: 'Ghana', flag: '🇬🇭', phone: '+233' },
  { code: 'GR', name: 'Greece', flag: '🇬🇷', phone: '+30' },
  { code: 'GD', name: 'Grenada', flag: '🇬🇩', phone: '+1473' },
  { code: 'GT', name: 'Guatemala', flag: '🇬🇹', phone: '+502' },
  { code: 'GN', name: 'Guinea', flag: '🇬🇳', phone: '+224' },
  { code: 'GW', name: 'Guinea-Bissau', flag: '🇬🇼', phone: '+245' },
  { code: 'GY', name: 'Guyana', flag: '🇬🇾', phone: '+592' },
  { code: 'HT', name: 'Haiti', flag: '🇭🇹', phone: '+509' },
  { code: 'HN', name: 'Honduras', flag: '🇭🇳', phone: '+504' },
  { code: 'HU', name: 'Hungary', flag: '🇭🇺', phone: '+36' },
  { code: 'IS', name: 'Iceland', flag: '🇮🇸', phone: '+354' },
  { code: 'IN', name: 'India', flag: '🇮🇳', phone: '+91' },
  { code: 'ID', name: 'Indonesia', flag: '🇮🇩', phone: '+62' },
  { code: 'IR', name: 'Iran', flag: '🇮🇷', phone: '+98' },
  { code: 'IQ', name: 'Iraq', flag: '🇮🇶', phone: '+964' },
  { code: 'IE', name: 'Ireland', flag: '🇮🇪', phone: '+353' },
  { code: 'IL', name: 'Israel', flag: '🇮🇱', phone: '+972' },
  { code: 'IT', name: 'Italy', flag: '🇮🇹', phone: '+39' },
  { code: 'JM', name: 'Jamaica', flag: '🇯🇲', phone: '+1876' },
  { code: 'JP', name: 'Japan', flag: '🇯🇵', phone: '+81' },
  { code: 'JO', name: 'Jordan', flag: '🇯🇴', phone: '+962' },
  { code: 'KZ', name: 'Kazakhstan', flag: '🇰🇿', phone: '+7' },
  { code: 'KE', name: 'Kenya', flag: '🇰🇪', phone: '+254' },
  { code: 'KI', name: 'Kiribati', flag: '🇰🇮', phone: '+686' },
  { code: 'KP', name: 'Korea (North)', flag: '🇰🇵', phone: '+850' },
  { code: 'KR', name: 'Korea (South)', flag: '🇰🇷', phone: '+82' },
  { code: 'KW', name: 'Kuwait', flag: '🇰🇼', phone: '+965' },
  { code: 'KG', name: 'Kyrgyzstan', flag: '🇰🇬', phone: '+996' },
  { code: 'LA', name: 'Laos', flag: '🇱🇦', phone: '+856' },
  { code: 'LV', name: 'Latvia', flag: '🇱🇻', phone: '+371' },
  { code: 'LB', name: 'Lebanon', flag: '🇱🇧', phone: '+961' },
  { code: 'LS', name: 'Lesotho', flag: '🇱🇸', phone: '+266' },
  { code: 'LR', name: 'Liberia', flag: '🇱🇷', phone: '+231' },
  { code: 'LY', name: 'Libya', flag: '🇱🇾', phone: '+218' },
  { code: 'LI', name: 'Liechtenstein', flag: '🇱🇮', phone: '+423' },
  { code: 'LT', name: 'Lithuania', flag: '🇱🇹', phone: '+370' },
  { code: 'LU', name: 'Luxembourg', flag: '🇱🇺', phone: '+352' },
  { code: 'MG', name: 'Madagascar', flag: '🇲🇬', phone: '+261' },
  { code: 'MW', name: 'Malawi', flag: '🇲🇼', phone: '+265' },
  { code: 'MY', name: 'Malaysia', flag: '🇲🇾', phone: '+60' },
  { code: 'MV', name: 'Maldives', flag: '🇲🇻', phone: '+960' },
  { code: 'ML', name: 'Mali', flag: '🇲🇱', phone: '+223' },
  { code: 'MT', name: 'Malta', flag: '🇲🇹', phone: '+356' },
  { code: 'MH', name: 'Marshall Islands', flag: '🇲🇭', phone: '+692' },
  { code: 'MR', name: 'Mauritania', flag: '🇲🇷', phone: '+222' },
  { code: 'MU', name: 'Mauritius', flag: '🇲🇺', phone: '+230' },
  { code: 'MX', name: 'Mexico', flag: '🇲🇽', phone: '+52' },
  { code: 'FM', name: 'Micronesia', flag: '🇫🇲', phone: '+691' },
  { code: 'MD', name: 'Moldova', flag: '🇲🇩', phone: '+373' },
  { code: 'MC', name: 'Monaco', flag: '🇲🇨', phone: '+377' },
  { code: 'MN', name: 'Mongolia', flag: '🇲🇳', phone: '+976' },
  { code: 'ME', name: 'Montenegro', flag: '🇲🇪', phone: '+382' },
  { code: 'MA', name: 'Morocco', flag: '🇲🇦', phone: '+212' },
  { code: 'MZ', name: 'Mozambique', flag: '🇲🇿', phone: '+258' },
  { code: 'MM', name: 'Myanmar', flag: '🇲🇲', phone: '+95' },
  { code: 'NA', name: 'Namibia', flag: '🇳🇦', phone: '+264' },
  { code: 'NR', name: 'Nauru', flag: '🇳🇷', phone: '+674' },
  { code: 'NP', name: 'Nepal', flag: '🇳🇵', phone: '+977' },
  { code: 'NL', name: 'Netherlands', flag: '🇳🇱', phone: '+31' },
  { code: 'NZ', name: 'New Zealand', flag: '🇳🇿', phone: '+64' },
  { code: 'NI', name: 'Nicaragua', flag: '🇳🇮', phone: '+505' },
  { code: 'NE', name: 'Niger', flag: '🇳🇪', phone: '+227' },
  { code: 'NG', name: 'Nigeria', flag: '🇳🇬', phone: '+234' },
  { code: 'MK', name: 'North Macedonia', flag: '🇲🇰', phone: '+389' },
  { code: 'NO', name: 'Norway', flag: '🇳🇴', phone: '+47' },
  { code: 'OM', name: 'Oman', flag: '🇴🇲', phone: '+968' },
  { code: 'PK', name: 'Pakistan', flag: '🇵🇰', phone: '+92' },
  { code: 'PW', name: 'Palau', flag: '🇵🇼', phone: '+680' },
  { code: 'PA', name: 'Panama', flag: '🇵🇦', phone: '+507' },
  { code: 'PG', name: 'Papua New Guinea', flag: '🇵🇬', phone: '+675' },
  { code: 'PY', name: 'Paraguay', flag: '🇵🇾', phone: '+595' },
  { code: 'PE', name: 'Peru', flag: '🇵🇪', phone: '+51' },
  { code: 'PH', name: 'Philippines', flag: '🇵🇭', phone: '+63' },
  { code: 'PL', name: 'Poland', flag: '🇵🇱', phone: '+48' },
  { code: 'PT', name: 'Portugal', flag: '🇵🇹', phone: '+351' },
  { code: 'QA', name: 'Qatar', flag: '🇶🇦', phone: '+974' },
  { code: 'RO', name: 'Romania', flag: '🇷🇴', phone: '+40' },
  { code: 'RU', name: 'Russia', flag: '🇷🇺', phone: '+7' },
  { code: 'RW', name: 'Rwanda', flag: '🇷🇼', phone: '+250' },
  { code: 'KN', name: 'Saint Kitts and Nevis', flag: '🇰🇳', phone: '+1869' },
  { code: 'LC', name: 'Saint Lucia', flag: '🇱🇨', phone: '+1758' },
  { code: 'VC', name: 'Saint Vincent and the Grenadines', flag: '🇻🇨', phone: '+1784' },
  { code: 'WS', name: 'Samoa', flag: '🇼🇸', phone: '+685' },
  { code: 'SM', name: 'San Marino', flag: '🇸🇲', phone: '+378' },
  { code: 'ST', name: 'São Tomé and Príncipe', flag: '🇸🇹', phone: '+239' },
  { code: 'SA', name: 'Saudi Arabia', flag: '🇸🇦', phone: '+966' },
  { code: 'SN', name: 'Senegal', flag: '🇸🇳', phone: '+221' },
  { code: 'RS', name: 'Serbia', flag: '🇷🇸', phone: '+381' },
  { code: 'SC', name: 'Seychelles', flag: '🇸🇨', phone: '+248' },
  { code: 'SL', name: 'Sierra Leone', flag: '🇸🇱', phone: '+232' },
  { code: 'SG', name: 'Singapore', flag: '🇸🇬', phone: '+65' },
  { code: 'SK', name: 'Slovakia', flag: '🇸🇰', phone: '+421' },
  { code: 'SI', name: 'Slovenia', flag: '🇸🇮', phone: '+386' },
  { code: 'SB', name: 'Solomon Islands', flag: '🇸🇧', phone: '+677' },
  { code: 'SO', name: 'Somalia', flag: '🇸🇴', phone: '+252' },
  { code: 'ZA', name: 'South Africa', flag: '🇿🇦', phone: '+27' },
  { code: 'SS', name: 'South Sudan', flag: '🇸🇸', phone: '+211' },
  { code: 'ES', name: 'Spain', flag: '🇪🇸', phone: '+34' },
  { code: 'LK', name: 'Sri Lanka', flag: '🇱🇰', phone: '+94' },
  { code: 'SD', name: 'Sudan', flag: '🇸🇩', phone: '+249' },
  { code: 'SR', name: 'Suriname', flag: '🇸🇷', phone: '+597' },
  { code: 'SE', name: 'Sweden', flag: '🇸🇪', phone: '+46' },
  { code: 'CH', name: 'Switzerland', flag: '🇨🇭', phone: '+41' },
  { code: 'SY', name: 'Syria', flag: '🇸🇾', phone: '+963' },
  { code: 'TW', name: 'Taiwan', flag: '🇹🇼', phone: '+886' },
  { code: 'TJ', name: 'Tajikistan', flag: '🇹🇯', phone: '+992' },
  { code: 'TZ', name: 'Tanzania', flag: '🇹🇿', phone: '+255' },
  { code: 'TH', name: 'Thailand', flag: '🇹🇭', phone: '+66' },
  { code: 'TL', name: 'Timor-Leste', flag: '🇹🇱', phone: '+670' },
  { code: 'TG', name: 'Togo', flag: '🇹🇬', phone: '+228' },
  { code: 'TO', name: 'Tonga', flag: '🇹🇴', phone: '+676' },
  { code: 'TT', name: 'Trinidad and Tobago', flag: '🇹🇹', phone: '+1868' },
  { code: 'TN', name: 'Tunisia', flag: '🇹🇳', phone: '+216' },
  { code: 'TR', name: 'Turkey', flag: '🇹🇷', phone: '+90' },
  { code: 'TM', name: 'Turkmenistan', flag: '🇹🇲', phone: '+993' },
  { code: 'TV', name: 'Tuvalu', flag: '🇹🇻', phone: '+688' },
  { code: 'UG', name: 'Uganda', flag: '🇺🇬', phone: '+256' },
  { code: 'UA', name: 'Ukraine', flag: '🇺🇦', phone: '+380' },
  { code: 'AE', name: 'United Arab Emirates', flag: '🇦🇪', phone: '+971' },
  { code: 'GB', name: 'United Kingdom', flag: '🇬🇧', phone: '+44' },
  { code: 'US', name: 'United States', flag: '🇺🇸', phone: '+1' },
  { code: 'UY', name: 'Uruguay', flag: '🇺🇾', phone: '+598' },
  { code: 'UZ', name: 'Uzbekistan', flag: '🇺🇿', phone: '+998' },
  { code: 'VU', name: 'Vanuatu', flag: '🇻🇺', phone: '+678' },
  { code: 'VA', name: 'Vatican City', flag: '🇻🇦', phone: '+379' },
  { code: 'VE', name: 'Venezuela', flag: '🇻🇪', phone: '+58' },
  { code: 'VN', name: 'Vietnam', flag: '🇻🇳', phone: '+84' },
  { code: 'YE', name: 'Yemen', flag: '🇾🇪', phone: '+967' },
  { code: 'ZM', name: 'Zambia', flag: '🇿🇲', phone: '+260' },
  { code: 'ZW', name: 'Zimbabwe', flag: '🇿🇼', phone: '+263' }
];

// Pays par défaut (peut être détecté par géolocalisation)
const DEFAULT_COUNTRY = 'KE'; // Kenya par défaut pour Likico

// Langues disponibles - Liste universelle basée sur ISO 639-1 avec noms natifs
const LANGUAGES = [
  // Langues les plus parlées dans le monde
  { code: 'en', name: 'English', nativeName: 'English', speakers: '1.5B', flag: '🇺🇸' },
  { code: 'zh', name: 'Chinese', nativeName: '中文', speakers: '1.1B', flag: '🇨🇳' },
  { code: 'hi', name: 'Hindi', nativeName: 'हिन्दी', speakers: '600M', flag: '🇮🇳' },
  { code: 'es', name: 'Spanish', nativeName: 'Español', speakers: '500M', flag: '🇪🇸' },
  { code: 'fr', name: 'French', nativeName: 'Français', speakers: '280M', flag: '🇫🇷' },
  { code: 'ar', name: 'Arabic', nativeName: 'العربية', speakers: '422M', flag: '🇸🇦' },
  { code: 'bn', name: 'Bengali', nativeName: 'বাংলা', speakers: '300M', flag: '🇧🇩' },
  { code: 'pt', name: 'Portuguese', nativeName: 'Português', speakers: '260M', flag: '🇵🇹' },
  { code: 'ru', name: 'Russian', nativeName: 'Русский', speakers: '258M', flag: '🇷🇺' },
  { code: 'ur', name: 'Urdu', nativeName: 'اردو', speakers: '230M', flag: '🇵🇰' },
  
  // Langues indonésiennes et asiatiques
  { code: 'id', name: 'Indonesian', nativeName: 'Bahasa Indonesia', speakers: '200M', flag: '🇮🇩' },
  { code: 'ja', name: 'Japanese', nativeName: '日本語', speakers: '125M', flag: '🇯🇵' },
  { code: 'ms', name: 'Malay', nativeName: 'Bahasa Melayu', speakers: '77M', flag: '🇲🇾' },
  { code: 'ko', name: 'Korean', nativeName: '한국어', speakers: '77M', flag: '🇰🇷' },
  { code: 'vi', name: 'Vietnamese', nativeName: 'Tiếng Việt', speakers: '76M', flag: '🇻🇳' },
  { code: 'th', name: 'Thai', nativeName: 'ไทย', speakers: '60M', flag: '🇹🇭' },
  
  // Langues africaines
  { code: 'sw', name: 'Swahili', nativeName: 'Kiswahili', speakers: '200M', flag: '🇰🇪' },
  { code: 'ha', name: 'Hausa', nativeName: 'Harshen Hausa', speakers: '70M', flag: '🇳🇬' },
  { code: 'yo', name: 'Yoruba', nativeName: 'Yorùbá', speakers: '50M', flag: '🇳🇬' },
  { code: 'ig', name: 'Igbo', nativeName: 'Asụsụ Igbo', speakers: '44M', flag: '🇳🇬' },
  { code: 'am', name: 'Amharic', nativeName: 'አማርኛ', speakers: '57M', flag: '🇪🇹' },
  { code: 'rw', name: 'Kinyarwanda', nativeName: 'Ikinyarwanda', speakers: '12M', flag: '🇷🇼' },
  { code: 'zu', name: 'Zulu', nativeName: 'isiZulu', speakers: '12M', flag: '🇿🇦' },
  { code: 'xh', name: 'Xhosa', nativeName: 'isiXhosa', speakers: '8M', flag: '🇿🇦' },
  
  // Langues européennes
  { code: 'de', name: 'German', nativeName: 'Deutsch', speakers: '100M', flag: '🇩🇪' },
  { code: 'it', name: 'Italian', nativeName: 'Italiano', speakers: '65M', flag: '🇮🇹' },
  { code: 'tr', name: 'Turkish', nativeName: 'Türkçe', speakers: '88M', flag: '🇹🇷' },
  { code: 'pl', name: 'Polish', nativeName: 'Polski', speakers: '45M', flag: '🇵🇱' },
  { code: 'uk', name: 'Ukrainian', nativeName: 'Українська', speakers: '40M', flag: '🇺🇦' },
  { code: 'ro', name: 'Romanian', nativeName: 'Română', speakers: '24M', flag: '🇷🇴' },
  { code: 'nl', name: 'Dutch', nativeName: 'Nederlands', speakers: '23M', flag: '🇳🇱' },
  { code: 'el', name: 'Greek', nativeName: 'Ελληνικά', speakers: '13M', flag: '🇬🇷' },
  { code: 'cs', name: 'Czech', nativeName: 'Čeština', speakers: '10M', flag: '🇨🇿' },
  { code: 'sv', name: 'Swedish', nativeName: 'Svenska', speakers: '10M', flag: '🇸🇪' },
  { code: 'hu', name: 'Hungarian', nativeName: 'Magyar', speakers: '13M', flag: '🇭🇺' },
  { code: 'no', name: 'Norwegian', nativeName: 'Norsk', speakers: '5M', flag: '🇳🇴' },
  { code: 'da', name: 'Danish', nativeName: 'Dansk', speakers: '6M', flag: '🇩🇰' },
  { code: 'fi', name: 'Finnish', nativeName: 'Suomi', speakers: '5M', flag: '🇫🇮' },
  
  // Langues des Amériques
  { code: 'qu', name: 'Quechua', nativeName: 'Runa Simi', speakers: '10M', flag: '🇵🇪' },
  { code: 'gn', name: 'Guaraní', nativeName: 'Avañe\'ẽ', speakers: '7M', flag: '🇵🇾' },
  
  // Autres langues importantes
  { code: 'he', name: 'Hebrew', nativeName: 'עברית', speakers: '9M', flag: '🇮🇱' },
  { code: 'fa', name: 'Persian', nativeName: 'فارسی', speakers: '110M', flag: '🇮🇷' },
  { code: 'ta', name: 'Tamil', nativeName: 'தமிழ்', speakers: '75M', flag: '🇮🇳' },
  { code: 'te', name: 'Telugu', nativeName: 'తెలుగు', speakers: '82M', flag: '🇮🇳' },
  { code: 'ml', name: 'Malayalam', nativeName: 'മലയാളം', speakers: '38M', flag: '🇮🇳' },
  { code: 'kn', name: 'Kannada', nativeName: 'ಕನ್ನಡ', speakers: '44M', flag: '🇮🇳' },
  { code: 'pa', name: 'Punjabi', nativeName: 'ਪੰਜਾਬੀ', speakers: '125M', flag: '🇮🇳' },
  { code: 'gu', name: 'Gujarati', nativeName: 'ગુજરાતી', speakers: '60M', flag: '🇮🇳' },
  { code: 'or', name: 'Odia', nativeName: 'ଓଡ଼ିଆ', speakers: '45M', flag: '🇮🇳' },
  { code: 'mr', name: 'Marathi', nativeName: 'मराठी', speakers: '83M', flag: '🇮🇳' },
  
  // Langues supplémentaires importantes
  { code: 'bg', name: 'Bulgarian', nativeName: 'Български', speakers: '8M', flag: '🇧🇬' },
  { code: 'hr', name: 'Croatian', nativeName: 'Hrvatski', speakers: '5M', flag: '🇭🇷' },
  { code: 'sr', name: 'Serbian', nativeName: 'Српски', speakers: '12M', flag: '🇷🇸' },
  { code: 'sk', name: 'Slovak', nativeName: 'Slovenčina', speakers: '5M', flag: '🇸🇰' },
  { code: 'sl', name: 'Slovenian', nativeName: 'Slovenščina', speakers: '2M', flag: '🇸🇮' },
  { code: 'lt', name: 'Lithuanian', nativeName: 'Lietuvių', speakers: '3M', flag: '🇱🇹' },
  { code: 'lv', name: 'Latvian', nativeName: 'Latviešu', speakers: '2M', flag: '🇱🇻' },
  { code: 'et', name: 'Estonian', nativeName: 'Eesti', speakers: '1M', flag: '🇪🇪' },
  { code: 'mt', name: 'Maltese', nativeName: 'Malti', speakers: '520K', flag: '🇲🇹' },
  { code: 'is', name: 'Icelandic', nativeName: 'Íslenska', speakers: '350K', flag: '🇮🇸' }
];

// Langue par défaut (fallback)
const DEFAULT_LANGUAGE = 'en';

const RegistrationForm = ({ onRegisterSuccess, onSwitchToLogin }) => {
  // États du formulaire
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    password: '',
    confirmPassword: '',
    country: DEFAULT_COUNTRY, // Utilise le pays par défaut défini
    language: DEFAULT_LANGUAGE, // Utilise la langue par défaut définie
    profilePhoto: null,
    acceptTerms: false,
    receiveNewsletter: true
  });

  // États de validation
  const [validationState, setValidationState] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState({ type: '', message: '', visible: false });
  const [step, setStep] = useState('form'); // 'form', 'verification', 'success'
  const [verificationCode, setVerificationCode] = useState('');
  const [languageSearchTerm, setLanguageSearchTerm] = useState(''); // Pour la recherche de langues
  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false); // Pour afficher/masquer la liste
  const [countrySearchTerm, setCountrySearchTerm] = useState(''); // Pour la recherche de pays
  const [showCountryDropdown, setShowCountryDropdown] = useState(false); // Pour afficher/masquer la liste des pays
  const [isDetectingLocation, setIsDetectingLocation] = useState(false); // État de détection géolocalisation

  // Détection automatique du pays au chargement du composant
  useEffect(() => {
    // Détecter le pays seulement si c'est le pays par défaut
    if (formData.country === DEFAULT_COUNTRY) {
      detectUserCountry();
    }
  }, []); // Se lance une seule fois au montage du composant

  // Validation en temps réel
  const validateField = (name, value, formData) => {
    const errors = {};

    switch (name) {
      case 'firstName':
        if (!value.trim()) {
          errors.firstName = 'Le prénom est obligatoire';
        } else if (value.trim().length < 2) {
          errors.firstName = 'Le prénom doit contenir au moins 2 caractères';
        }
        break;

      case 'lastName':
        if (!value.trim()) {
          errors.lastName = 'Le nom est obligatoire';
        } else if (value.trim().length < 2) {
          errors.lastName = 'Le nom doit contenir au moins 2 caractères';
        }
        break;

      case 'email':
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!value.trim()) {
          errors.email = 'L\'email est obligatoire';
        } else if (!emailRegex.test(value)) {
          errors.email = 'Format d\'email invalide';
        }
        break;

      case 'phone':
        if (!value.trim()) {
          errors.phone = 'Le numéro de téléphone est obligatoire';
        } else if (!/^[+\d\s\-()]{8,15}$/.test(value.replace(/\s/g, ''))) {
          errors.phone = 'Format de téléphone invalide';
        }
        break;

      case 'password':
        if (!value) {
          errors.password = 'Le mot de passe est obligatoire';
        } else if (value.length < 8) {
          errors.password = 'Le mot de passe doit contenir au moins 8 caractères';
        } else if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/.test(value)) {
          errors.password = 'Le mot de passe doit contenir au moins une minuscule, une majuscule et un chiffre';
        }
        break;

      case 'confirmPassword':
        if (!value) {
          errors.confirmPassword = 'La confirmation du mot de passe est obligatoire';
        } else if (value !== formData.password) {
          errors.confirmPassword = 'Les mots de passe ne correspondent pas';
        }
        break;

      case 'acceptTerms':
        if (!value) {
          errors.acceptTerms = 'Vous devez accepter les conditions générales';
        }
        break;

      case 'language':
        if (!value) {
          errors.language = 'Veuillez sélectionner une langue';
        } else if (!LANGUAGES.find(lang => lang.code === value)) {
          errors.language = 'Langue sélectionnée invalide';
        }
        break;

      case 'country':
        if (!value) {
          errors.country = 'Le pays de résidence est obligatoire';
        } else if (!COUNTRIES.find(country => country.code === value)) {
          errors.country = 'Pays sélectionné invalide';
        }
        break;

      default:
        break;
    }

    return errors;
  };

  // Gestionnaire de changement de champ
  const handleFieldChange = (name, value) => {
    setFormData(prev => ({ ...prev, [name]: value }));
    
    // Validation en temps réel
    const errors = validateField(name, value, { ...formData, [name]: value });
    setValidationState(prev => ({
      ...prev,
      [name]: errors[name] ? { isValid: false, message: errors[name] } : { isValid: true, message: '' }
    }));
  };

  // Fonction pour filtrer les langues selon la recherche
  const filteredLanguages = LANGUAGES.filter(lang => 
    lang.name.toLowerCase().includes(languageSearchTerm.toLowerCase()) ||
    lang.nativeName.toLowerCase().includes(languageSearchTerm.toLowerCase()) ||
    lang.code.toLowerCase().includes(languageSearchTerm.toLowerCase())
  );

  // Fonction pour filtrer les pays selon la recherche
  const filteredCountries = COUNTRIES.filter(country => 
    country.name.toLowerCase().includes(countrySearchTerm.toLowerCase()) ||
    country.code.toLowerCase().includes(countrySearchTerm.toLowerCase()) ||
    country.phone.includes(countrySearchTerm)
  );

  // Fonction de géolocalisation pour détecter le pays
  const detectUserCountry = async () => {
    setIsDetectingLocation(true);
    try {
      // Tenter d'obtenir la géolocalisation
      if ("geolocation" in navigator) {
        const position = await new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject, {
            timeout: 10000,
            enableHighAccuracy: false,
            maximumAge: 300000 // 5 minutes de cache
          });
        });

        // Utiliser un service de géolocalisation reverse (exemple avec ipapi.co qui ne nécessite pas de clé)
        try {
          const response = await fetch('https://ipapi.co/json/');
          const data = await response.json();
          
          if (data.country_code) {
            const detectedCountry = COUNTRIES.find(c => c.code === data.country_code.toUpperCase());
            if (detectedCountry) {
              handleFieldChange('country', detectedCountry.code);
              showFeedback('success', `📍 Pays détecté : ${detectedCountry.name}`);
            } else {
              // Fallback au pays par défaut
              handleFieldChange('country', DEFAULT_COUNTRY);
            }
          } else {
            handleFieldChange('country', DEFAULT_COUNTRY);
          }
        } catch (apiError) {
          console.warn('IP geolocation API failed:', apiError);
          // Fallback au pays par défaut
          handleFieldChange('country', DEFAULT_COUNTRY);
        }
      } else {
        console.warn('Geolocation not supported');
        handleFieldChange('country', DEFAULT_COUNTRY);
      }
    } catch (error) {
      console.warn('Geolocation detection failed:', error);
      // Fallback au pays par défaut
      handleFieldChange('country', DEFAULT_COUNTRY);
      showFeedback('info', '📍 Géolocalisation non disponible, Kenya sélectionné par défaut');
    } finally {
      setIsDetectingLocation(false);
    }
  };

  // Gestionnaire pour sélectionner un pays
  const handleCountrySelect = (countryCode) => {
    handleFieldChange('country', countryCode);
    setCountrySearchTerm('');
    setShowCountryDropdown(false);
  };

  // Fonction pour obtenir le nom d'affichage de la langue
  const getLanguageDisplayName = (language) => {
    return `${language.nativeName} (${language.name})`;
  };

  // Gestionnaire pour sélectionner une langue
  const handleLanguageSelect = (languageCode) => {
    handleFieldChange('language', languageCode);
    setLanguageSearchTerm('');
    setShowLanguageDropdown(false);
  };

  // Gestionnaire d'upload de photo
  const handlePhotoUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (file.size > 5 * 1024 * 1024) { // 5MB max
        showFeedback('error', 'La photo ne doit pas dépasser 5 MB');
        return;
      }
      
      if (!file.type.startsWith('image/')) {
        showFeedback('error', 'Veuillez sélectionner un fichier image');
        return;
      }

      setFormData(prev => ({ ...prev, profilePhoto: file }));
    }
  };

  // Affichage du feedback
  const showFeedback = (type, message) => {
    setFeedback({ type, message, visible: true });
    setTimeout(() => {
      setFeedback(prev => ({ ...prev, visible: false }));
    }, 5000);
  };

  // Validation complète du formulaire
  const validateForm = () => {
    const errors = {};
    
    // Champs obligatoires à valider
    const requiredFields = ['firstName', 'lastName', 'email', 'phone', 'password', 'confirmPassword', 'country', 'language', 'acceptTerms'];
    
    requiredFields.forEach(field => {
      const fieldErrors = validateField(field, formData[field], formData);
      Object.assign(errors, fieldErrors);
    });

    return errors;
  };

  // Soumission du formulaire
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      const firstError = Object.values(errors)[0];
      showFeedback('error', firstError);
      return;
    }

    setLoading(true);
    
    try {
      // Adapter les données au modèle UserCreate du backend
      const registrationData = {
        username: `${formData.firstName} ${formData.lastName}`.trim(),
        email: formData.email,
        phone_number: formData.phone,
        password: formData.password,
        preferred_language: formData.language,
        preferred_currency: 'KES' // Valeur par défaut selon le modèle backend
      };

      const response = await fetch(`${API}/auth/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(registrationData)
      });

      const data = await response.json();
      
      if (response.ok) {
        // Si l'inscription est réussie, connecter directement l'utilisateur
        localStorage.setItem('token', data.access_token);
        localStorage.setItem('user', JSON.stringify(data.user));
        setStep('success');
        showFeedback('success', 'Inscription réussie ! Vous êtes maintenant connecté.');
      } else {
        showFeedback('error', data.detail || 'Erreur lors de l\'inscription');
      }
    } catch (error) {
      console.error('Registration error:', error);
      showFeedback('error', 'Erreur de connexion. Veuillez réessayer.');
    } finally {
      setLoading(false);
    }
  };

  // Rendu du formulaire principal
  const renderRegistrationForm = () => (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50 py-6 px-4">
      <div className="max-w-md mx-auto">
        {/* En-tête avec bouton Retour */}
        <div className="flex items-center mb-6">
          <button
            type="button"
            onClick={onSwitchToLogin}
            className="flex items-center text-gray-600 hover:text-gray-800 transition-colors mr-4 p-2 hover:bg-gray-100 rounded-md"
            aria-label="Retour à la page de connexion"
          >
            <ArrowLeft className="w-5 h-5 mr-1" />
            Retour
          </button>
          
          <div className="flex-1 text-center">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">Créer un compte</h1>
            <p className="text-gray-600">Rejoignez la communauté Likico</p>
          </div>
        </div>

        {/* Feedback */}
        {feedback.visible && (
          <div className={`mb-4 p-4 rounded-lg ${
            feedback.type === 'error' ? 'bg-red-100 border-l-4 border-red-500 text-red-700' : 
            'bg-green-100 border-l-4 border-green-500 text-green-700'
          }`}>
            <div className="flex items-center">
              {feedback.type === 'error' ? <X className="w-5 h-5 mr-2" /> : <Check className="w-5 h-5 mr-2" />}
              {feedback.message}
            </div>
          </div>
        )}

        {/* Formulaire */}
        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Prénom et Nom */}
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Prénom *
              </label>
              <div className="relative">
                <User className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
                <input
                  type="text"
                  value={formData.firstName}
                  onChange={(e) => handleFieldChange('firstName', e.target.value)}
                  className={`w-full pl-10 pr-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 ${
                    validationState.firstName?.isValid === false ? 'border-red-500' : 
                    validationState.firstName?.isValid === true ? 'border-green-500' : 'border-gray-300'
                  }`}
                  placeholder="Votre prénom"
                />
              </div>
              {validationState.firstName?.message && (
                <p className="text-red-500 text-xs mt-1">{validationState.firstName.message}</p>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Nom *
              </label>
              <div className="relative">
                <User className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
                <input
                  type="text"
                  value={formData.lastName}
                  onChange={(e) => handleFieldChange('lastName', e.target.value)}
                  className={`w-full pl-10 pr-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 ${
                    validationState.lastName?.isValid === false ? 'border-red-500' : 
                    validationState.lastName?.isValid === true ? 'border-green-500' : 'border-gray-300'
                  }`}
                  placeholder="Votre nom"
                />
              </div>
              {validationState.lastName?.message && (
                <p className="text-red-500 text-xs mt-1">{validationState.lastName.message}</p>
              )}
            </div>
          </div>

          {/* Email */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Adresse e-mail *
            </label>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
              <input
                type="email"
                value={formData.email}
                onChange={(e) => handleFieldChange('email', e.target.value)}
                className={`w-full pl-10 pr-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 ${
                  validationState.email?.isValid === false ? 'border-red-500' : 
                  validationState.email?.isValid === true ? 'border-green-500' : 'border-gray-300'
                }`}
                placeholder="votre@email.com"
              />
            </div>
            {validationState.email?.message && (
              <p className="text-red-500 text-xs mt-1">{validationState.email.message}</p>
            )}
          </div>

          {/* Pays et Téléphone */}
          <div className="grid grid-cols-1 gap-3">
            {/* Pays de résidence avec recherche et géolocalisation */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Pays de résidence *
              </label>
              <div className="relative">
                <div className="relative">
                  <Globe className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400 z-10" />
                  <input
                    type="text"
                    value={countrySearchTerm || (formData.country ? `${COUNTRIES.find(c => c.code === formData.country)?.flag} ${COUNTRIES.find(c => c.code === formData.country)?.name}` : '')}
                    onChange={(e) => {
                      setCountrySearchTerm(e.target.value);
                      setShowCountryDropdown(true);
                    }}
                    onFocus={() => setShowCountryDropdown(true)}
                    className={`w-full pl-10 pr-20 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 ${
                      validationState.country?.isValid === false ? 'border-red-500' : 
                      validationState.country?.isValid === true ? 'border-green-500' : 'border-gray-300'
                    }`}
                    placeholder="Rechercher ou sélectionner votre pays..."
                  />
                  
                  {/* Bouton de géolocalisation */}
                  <button
                    type="button"
                    onClick={detectUserCountry}
                    disabled={isDetectingLocation}
                    className="absolute right-8 top-1/2 transform -translate-y-1/2 text-blue-500 hover:text-blue-700 disabled:opacity-50"
                    title="Détecter automatiquement mon pays"
                  >
                    {isDetectingLocation ? (
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-500"></div>
                    ) : (
                      '📍'
                    )}
                  </button>
                  
                  <ChevronDown 
                    className={`absolute right-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400 transition-transform ${
                      showCountryDropdown ? 'rotate-180' : ''
                    }`} 
                  />
                </div>
                
                {/* Liste déroulante des pays */}
                {showCountryDropdown && (
                  <div className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-80 overflow-y-auto">
                    {/* Barre de recherche intégrée */}
                    <div className="sticky top-0 bg-gray-50 p-3 border-b">
                      <div className="relative mb-2">
                        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
                        <input
                          type="text"
                          value={countrySearchTerm}
                          onChange={(e) => setCountrySearchTerm(e.target.value)}
                          className="w-full pl-10 pr-3 py-2 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
                          placeholder="Rechercher un pays..."
                        />
                      </div>
                      <div className="flex items-center justify-between">
                        <p className="text-xs text-gray-500">
                          {filteredCountries.length} pays trouvé{filteredCountries.length > 1 ? 's' : ''}
                        </p>
                        <button
                          type="button"
                          onClick={detectUserCountry}
                          disabled={isDetectingLocation}
                          className="text-xs text-blue-600 hover:text-blue-800 disabled:opacity-50 flex items-center gap-1"
                        >
                          {isDetectingLocation ? (
                            <>
                              <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-blue-600"></div>
                              Détection...
                            </>
                          ) : (
                            <>
                              📍 Détecter mon pays
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                    
                    {/* Liste des pays filtrés */}
                    <div className="max-h-60 overflow-y-auto">
                      {filteredCountries.length > 0 ? (
                        filteredCountries.map(country => (
                          <button
                            key={country.code}
                            type="button"
                            onClick={() => handleCountrySelect(country.code)}
                            className={`w-full text-left px-4 py-3 hover:bg-blue-50 focus:bg-blue-50 focus:outline-none flex items-center justify-between group ${
                              formData.country === country.code ? 'bg-blue-100 border-l-4 border-blue-500' : ''
                            }`}
                          >
                            <div className="flex items-center space-x-3">
                              <span className="text-lg">{country.flag}</span>
                              <div>
                                <div className="font-medium text-gray-900">
                                  {country.name}
                                </div>
                                <div className="text-sm text-gray-500">
                                  {country.phone}
                                </div>
                              </div>
                            </div>
                            {formData.country === country.code && (
                              <Check className="w-4 h-4 text-blue-600" />
                            )}
                          </button>
                        ))
                      ) : (
                        <div className="px-4 py-6 text-center text-gray-500">
                          <Search className="w-8 h-8 mx-auto mb-2 text-gray-300" />
                          <p>Aucun pays trouvé</p>
                          <p className="text-xs">Essayez un autre terme de recherche</p>
                        </div>
                      )}
                    </div>
                    
                    {/* Bouton fermer */}
                    <div className="sticky bottom-0 bg-gray-50 p-3 border-t">
                      <button
                        type="button"
                        onClick={() => {
                          setShowCountryDropdown(false);
                          setCountrySearchTerm('');
                        }}
                        className="w-full text-sm text-gray-600 hover:text-gray-800 py-1"
                      >
                        Fermer la liste
                      </button>
                    </div>
                  </div>
                )}
                
                {/* Cliquer en dehors pour fermer */}
                {showCountryDropdown && (
                  <div 
                    className="fixed inset-0 z-40" 
                    onClick={() => {
                      setShowCountryDropdown(false);
                      setCountrySearchTerm('');
                    }}
                  />
                )}
              </div>
              
              {/* Message de validation */}
              {validationState.country?.message && (
                <p className="text-red-500 text-xs mt-1">{validationState.country.message}</p>
              )}
              
              {/* Affichage du pays sélectionné */}
              {formData.country && !showCountryDropdown && (
                <div className="mt-2 p-2 bg-green-50 border border-green-200 rounded-lg">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-2">
                      <span className="text-lg">
                        {COUNTRIES.find(c => c.code === formData.country)?.flag}
                      </span>
                      <div>
                        <span className="text-sm font-medium text-green-800">
                          {COUNTRIES.find(c => c.code === formData.country)?.name}
                        </span>
                        <div className="text-xs text-green-600">
                          Code téléphonique : {COUNTRIES.find(c => c.code === formData.country)?.phone}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Téléphone */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Numéro de téléphone *
              </label>
              <div className="relative">
                <Phone className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
                <input
                  type="tel"
                  value={formData.phone}
                  onChange={(e) => handleFieldChange('phone', e.target.value)}
                  className={`w-full pl-10 pr-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 ${
                    validationState.phone?.isValid === false ? 'border-red-500' : 
                    validationState.phone?.isValid === true ? 'border-green-500' : 'border-gray-300'
                  }`}
                  placeholder={`${COUNTRIES.find(c => c.code === formData.country)?.phone || '+XXX'} 123456789`}
                />
              </div>
              {validationState.phone?.message && (
                <p className="text-red-500 text-xs mt-1">{validationState.phone.message}</p>
              )}
              <p className="text-xs text-gray-500 mt-1">
                Format suggéré pour {COUNTRIES.find(c => c.code === formData.country)?.name || 'votre pays'}
              </p>
            </div>
          </div>

          {/* Mot de passe */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Mot de passe *
            </label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
              <input
                type={showPassword ? 'text' : 'password'}
                value={formData.password}
                onChange={(e) => handleFieldChange('password', e.target.value)}
                className={`w-full pl-10 pr-10 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 ${
                  validationState.password?.isValid === false ? 'border-red-500' : 
                  validationState.password?.isValid === true ? 'border-green-500' : 'border-gray-300'
                }`}
                placeholder="Votre mot de passe"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 transform -translate-y-1/2"
              >
                {showPassword ? <EyeOff className="w-5 h-5 text-gray-400" /> : <Eye className="w-5 h-5 text-gray-400" />}
              </button>
            </div>
            {validationState.password?.message && (
              <p className="text-red-500 text-xs mt-1">{validationState.password.message}</p>
            )}
          </div>

          {/* Confirmation mot de passe */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Confirmer le mot de passe *
            </label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
              <input
                type={showConfirmPassword ? 'text' : 'password'}
                value={formData.confirmPassword}
                onChange={(e) => handleFieldChange('confirmPassword', e.target.value)}
                className={`w-full pl-10 pr-10 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 ${
                  validationState.confirmPassword?.isValid === false ? 'border-red-500' : 
                  validationState.confirmPassword?.isValid === true ? 'border-green-500' : 'border-gray-300'
                }`}
                placeholder="Confirmer votre mot de passe"
              />
              <button
                type="button"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                className="absolute right-3 top-1/2 transform -translate-y-1/2"
              >
                {showConfirmPassword ? <EyeOff className="w-5 h-5 text-gray-400" /> : <Eye className="w-5 h-5 text-gray-400" />}
              </button>
            </div>
            {validationState.confirmPassword?.message && (
              <p className="text-red-500 text-xs mt-1">{validationState.confirmPassword.message}</p>
            )}
          </div>

          {/* Langue préférée avec recherche */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Langue préférée *
            </label>
            <div className="relative">
              <div className="relative">
                <Languages className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400 z-10" />
                <input
                  type="text"
                  value={languageSearchTerm || (formData.language ? getLanguageDisplayName(LANGUAGES.find(l => l.code === formData.language)) : '')}
                  onChange={(e) => {
                    setLanguageSearchTerm(e.target.value);
                    setShowLanguageDropdown(true);
                  }}
                  onFocus={() => setShowLanguageDropdown(true)}
                  className="w-full pl-10 pr-10 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Rechercher ou sélectionner une langue..."
                />
                <ChevronDown 
                  className={`absolute right-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400 transition-transform ${
                    showLanguageDropdown ? 'rotate-180' : ''
                  }`} 
                />
              </div>
              
              {/* Liste déroulante des langues */}
              {showLanguageDropdown && (
                <div className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto">
                  {/* Barre de recherche intégrée */}
                  <div className="sticky top-0 bg-gray-50 p-3 border-b">
                    <div className="relative">
                      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
                      <input
                        type="text"
                        value={languageSearchTerm}
                        onChange={(e) => setLanguageSearchTerm(e.target.value)}
                        className="w-full pl-10 pr-3 py-2 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
                        placeholder="Rechercher une langue..."
                      />
                    </div>
                    <p className="text-xs text-gray-500 mt-1">
                      {filteredLanguages.length} langue{filteredLanguages.length > 1 ? 's' : ''} trouvée{filteredLanguages.length > 1 ? 's' : ''}
                    </p>
                  </div>
                  
                  {/* Liste des langues filtrées */}
                  <div className="max-h-48 overflow-y-auto">
                    {filteredLanguages.length > 0 ? (
                      filteredLanguages.map(language => (
                        <button
                          key={language.code}
                          type="button"
                          onClick={() => handleLanguageSelect(language.code)}
                          className={`w-full text-left px-4 py-3 hover:bg-blue-50 focus:bg-blue-50 focus:outline-none flex items-center justify-between group ${
                            formData.language === language.code ? 'bg-blue-100 border-l-4 border-blue-500' : ''
                          }`}
                        >
                          <div className="flex items-center space-x-3">
                            <span className="text-lg">{language.flag}</span>
                            <div>
                              <div className="font-medium text-gray-900">
                                {language.nativeName}
                              </div>
                              <div className="text-sm text-gray-500">
                                {language.name} • {language.speakers} locuteurs
                              </div>
                            </div>
                          </div>
                          {formData.language === language.code && (
                            <Check className="w-4 h-4 text-blue-600" />
                          )}
                        </button>
                      ))
                    ) : (
                      <div className="px-4 py-6 text-center text-gray-500">
                        <Search className="w-8 h-8 mx-auto mb-2 text-gray-300" />
                        <p>Aucune langue trouvée</p>
                        <p className="text-xs">Essayez un autre terme de recherche</p>
                      </div>
                    )}
                  </div>
                  
                  {/* Bouton fermer */}
                  <div className="sticky bottom-0 bg-gray-50 p-3 border-t">
                    <button
                      type="button"
                      onClick={() => {
                        setShowLanguageDropdown(false);
                        setLanguageSearchTerm('');
                      }}
                      className="w-full text-sm text-gray-600 hover:text-gray-800 py-1"
                    >
                      Fermer la liste
                    </button>
                  </div>
                </div>
              )}
              
              {/* Cliquer en dehors pour fermer */}
              {showLanguageDropdown && (
                <div 
                  className="fixed inset-0 z-40" 
                  onClick={() => {
                    setShowLanguageDropdown(false);
                    setLanguageSearchTerm('');
                  }}
                />
              )}
            </div>
            
            {/* Affichage de la langue sélectionnée */}
            {formData.language && !showLanguageDropdown && (
              <div className="mt-2 p-2 bg-blue-50 border border-blue-200 rounded-lg">
                <div className="flex items-center space-x-2">
                  <span className="text-lg">
                    {LANGUAGES.find(l => l.code === formData.language)?.flag}
                  </span>
                  <span className="text-sm font-medium text-blue-800">
                    Langue sélectionnée : {getLanguageDisplayName(LANGUAGES.find(l => l.code === formData.language))}
                  </span>
                </div>
              </div>
            )}
          </div>

          {/* Photo de profil */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Photo de profil (optionnel)
            </label>
            <div className="flex items-center space-x-3">
              <div className="relative">
                <input
                  type="file"
                  accept="image/*"
                  onChange={handlePhotoUpload}
                  className="hidden"
                  id="profilePhoto"
                />
                <label
                  htmlFor="profilePhoto"
                  className="flex items-center justify-center w-12 h-12 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer hover:border-blue-500 hover:bg-blue-50"
                >
                  {formData.profilePhoto ? (
                    <img
                      src={URL.createObjectURL(formData.profilePhoto)}
                      alt="Profile preview"
                      className="w-full h-full object-cover rounded-lg"
                    />
                  ) : (
                    <Camera className="w-6 h-6 text-gray-400" />
                  )}
                </label>
              </div>
              <label
                htmlFor="profilePhoto"
                className="flex items-center px-4 py-2 border border-gray-300 rounded-lg cursor-pointer hover:bg-gray-50"
              >
                <Upload className="w-4 h-4 mr-2 text-gray-500" />
                <span className="text-sm text-gray-700">
                  {formData.profilePhoto ? 'Changer la photo' : 'Télécharger une photo'}
                </span>
              </label>
            </div>
            <p className="text-xs text-gray-500 mt-1">JPG, PNG ou GIF. Max 5 MB</p>
          </div>

          {/* Cases à cocher */}
          <div className="space-y-3">
            <div className="flex items-start">
              <div className="flex items-center h-5">
                <input
                  id="acceptTerms"
                  type="checkbox"
                  checked={formData.acceptTerms}
                  onChange={(e) => handleFieldChange('acceptTerms', e.target.checked)}
                  className={`w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 ${
                    validationState.acceptTerms?.isValid === false ? 'border-red-500' : ''
                  }`}
                />
              </div>
              <div className="ml-3 text-sm">
                <label htmlFor="acceptTerms" className="text-gray-700">
                  J'accepte les{' '}
                  <a href="/terms" className="text-blue-600 hover:text-blue-500 underline">
                    conditions générales d'utilisation
                  </a>{' '}
                  et la{' '}
                  <a href="/privacy" className="text-blue-600 hover:text-blue-500 underline">
                    politique de confidentialité
                  </a>
                  *
                </label>
                {validationState.acceptTerms?.message && (
                  <p className="text-red-500 text-xs mt-1">{validationState.acceptTerms.message}</p>
                )}
              </div>
            </div>

            <div className="flex items-start">
              <div className="flex items-center h-5">
                <input
                  id="receiveNewsletter"
                  type="checkbox"
                  checked={formData.receiveNewsletter}
                  onChange={(e) => handleFieldChange('receiveNewsletter', e.target.checked)}
                  className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                />
              </div>
              <div className="ml-3 text-sm">
                <label htmlFor="receiveNewsletter" className="text-gray-700">
                  Je souhaite recevoir des informations sur les nouveautés de Likico
                </label>
              </div>
            </div>
          </div>

          {/* Boutons de navigation */}
          <div className="flex space-x-4">
            {/* Bouton Retour */}
            <button
              type="button"
              onClick={onSwitchToLogin}
              className="flex-1 flex items-center justify-center px-4 py-3 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Retour
            </button>
            
            {/* Bouton Continuer/S'inscrire */}
            <button
              type="submit"
              disabled={loading}
              className={`flex-1 flex items-center justify-center px-4 py-3 border border-transparent rounded-lg text-sm font-medium text-white ${
                loading ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'
              } focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500`}
            >
              {loading ? (
                <div className="flex items-center">
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                  Inscription...
                </div>
              ) : (
                <div className="flex items-center">
                  <Shield className="w-4 h-4 mr-2" />
                  Continuer
                  <ArrowRight className="w-4 h-4 ml-2" />
                </div>
              )}
            </button>
          </div>

          {/* Lien de connexion - version discrète */}
          <div className="text-center">
            <p className="text-xs text-gray-500">
              Déjà inscrit·e ?{' '}
              <button
                type="button"
                onClick={onSwitchToLogin}
                className="text-blue-600 hover:text-blue-500 font-medium underline"
              >
                Se connecter
              </button>
            </p>
          </div>
        </form>
      </div>
    </div>
  );

  // Gestionnaire pour terminer l'inscription réussie
  const handleCompleteRegistration = () => {
    // Récupérer les données utilisateur depuis localStorage (stockées lors de l'inscription)
    const userData = JSON.parse(localStorage.getItem('user'));
    onRegisterSuccess(userData);
  };

  // Rendu du message de succès
  const renderSuccessMessage = () => (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50 flex items-center justify-center py-6 px-4">
      <div className="max-w-md w-full text-center">
        <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100 mb-6">
          <Check className="h-8 w-8 text-green-600" />
        </div>
        
        <h2 className="text-2xl font-bold text-gray-900 mb-4">
          Bienvenue dans Likico !
        </h2>
        
        <p className="text-gray-600 mb-8">
          Votre compte a été créé avec succès. Vous êtes maintenant connecté et pouvez rejoindre la communauté.
        </p>
        
        <button
          onClick={handleCompleteRegistration}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-4 rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
          Commencer
        </button>
      </div>
    </div>
  );

  // Rendu principal
  switch (step) {
    case 'success':
      return renderSuccessMessage();
    default:
      return renderRegistrationForm();
  }
};

export default RegistrationForm;